export function extractApiErrorMessage(error, fallbackMessage = 'Ocorreu um erro.') {
  if (!error) {
    return fallbackMessage;
  }

  const responseData = error?.response?.data;
  const responseStatus = error?.response?.status;

  if (responseData) {
    if (typeof responseData === 'string') {
      const trimmed = responseData.trim();
      if (trimmed) {
        return trimmed;
      }
    }

    const detail = responseData.detail ?? responseData.error ?? responseData.errors;
    if (detail) {
      if (typeof detail === 'string') {
        const trimmedDetail = detail.trim();
        if (trimmedDetail) {
          return trimmedDetail;
        }
      } else if (Array.isArray(detail)) {
        for (const item of detail) {
          if (!item) continue;
          const message = item.message || item.msg || item.detail;
          if (typeof message === 'string' && message.trim()) {
            return message.trim();
          }
        }
      } else if (typeof detail === 'object') {
        const message = detail.message || detail.msg;
        if (typeof message === 'string' && message.trim()) {
          return message.trim();
        }
      }
    }

    const messageFromResponse = responseData.message || responseData.error;
    if (typeof messageFromResponse === 'string' && messageFromResponse.trim()) {
      return messageFromResponse.trim();
    }
  }

  if (responseStatus === 424) {
    return 'WhatsApp indisponível no momento. Conecte o WhatsApp e tente novamente.';
  }

  const defaultMessage = error?.message;
  if (typeof defaultMessage === 'string' && defaultMessage.trim()) {
    return defaultMessage.trim();
  }

  return fallbackMessage;
}

const NETWORK_ERROR_CODE_SET = new Set(['ERR_NETWORK', 'ECONNABORTED']);

function isNetworkError(error) {
  if (!error) return false;
  const errorCode = typeof error?.code === 'string' ? error.code.toUpperCase() : '';
  if (NETWORK_ERROR_CODE_SET.has(errorCode)) return true;
  const rawMessage = typeof error?.message === 'string' ? error.message.toLowerCase() : '';
  return rawMessage.includes('network error') || rawMessage.includes('failed to fetch');
}

export function resolveCloseConversationErrorMessage(
  error,
  fallbackMessage = 'Erro ao encerrar atendimento.'
) {
  const status = Number(error?.response?.status);

  if (isNetworkError(error)) {
    return 'Falha de rede ao encerrar atendimento. Verifique sua conexão e tente novamente.';
  }

  if (status === 401 || status === 403) {
    return 'Sua sessão expirou ou você não tem permissão para encerrar este atendimento.';
  }

  if (status === 404) {
    return extractApiErrorMessage(
      error,
      'Atendimento não encontrado. Ele pode já ter sido encerrado ou você não tem acesso.'
    );
  }

  if (status === 409) {
    return extractApiErrorMessage(error, 'Este atendimento já está encerrado.');
  }

  if (Number.isFinite(status) && status >= 500) {
    return 'Erro interno no servidor ao encerrar atendimento. Tente novamente em instantes.';
  }

  return extractApiErrorMessage(error, fallbackMessage);
}

export function shouldRefreshConversationAfterCloseError(error) {
  const status = Number(error?.response?.status);
  return status === 404 || status === 409 || (Number.isFinite(status) && status >= 500);
}
